import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CommonComponent } from 'src/app/shared/components/common-component';
import { VeterinariaService } from 'src/core/veterinaria/veterianaria.service';
import { PublicidadTarjetas, Veterinaria } from 'src/core/veterinaria/veterinaria.types';

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.css']
})
export class AboutUsComponent extends CommonComponent implements OnInit {

  //veterinarias: Veterinaria[] = [];
  publicidad: PublicidadTarjetas[] = [];
  aliados: PublicidadTarjetas[] = [];

  constructor(
    private _veterinariaService: VeterinariaService,
    _snackBar: MatSnackBar
  ) {
    super(_snackBar);
  }

  ngOnInit(): void {
    // this.getVeterinarias();
    this.getPublicidad();
  }

  getPublicidad() {
    this._veterinariaService.getPublicidad().subscribe({
      next: (publicidades: PublicidadTarjetas[]) => {
        this.publicidad = publicidades;
        this.aliados = publicidades.filter(p => p.estado);
      },
      error: () => {
        this.publicidad = [];
        this.aliados = [];
      }
    });
  }
  /*getVeterinarias() {
    this._veterinariaService.veterinarias$.subscribe({
      next: (vets: Veterinaria[]) => {
        this.veterinarias = vets;
        console.log(this.veterinarias);

      },
      error: (error: any) => {
        console.log('err : ', error);
      }
    });
  }*/
}
